/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Meta_DescriptionInputs */

const es_ab_meta_description = /** @type {(inputs: Ab_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publica tu barco en Zarpar y gana cuando no lo usas. Registro sencillo, reservas seguras y comisión del 15% + IVA solo al alquilar.`)
};

const gl_ab_meta_description = /** @type {(inputs: Ab_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publica o teu barco en Zarpar e gaña cando non o usas. Rexistro sinxelo, reservas seguras e comisión do 15% + IVE só ao alugar.`)
};

const en_ab_meta_description = /** @type {(inputs: Ab_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List your boat on Zarpar and earn when you're not using it. Simple signup, secure bookings, 15% + VAT commission only when you rent out.`)
};

/**
* | output |
* | --- |
* | "List your boat on Zarpar and earn when you're not using it. Simple signup, secure bookings, 15% + VAT commission only when you rent out." |
*
* @param {Ab_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_meta_description = /** @type {((inputs?: Ab_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_meta_description(inputs)
	if (locale === "en") return en_ab_meta_description(inputs)
	return es_ab_meta_description(inputs)
});